<template>
  <div class="content-div" ref="contentToConvert">
    <button @click="save">保存</button>
    <button @click="doPDF">打印</button>
  </div>
</template>

<script>

import html2pdf from 'html2pdf.js';
export default {
  name: "HomeView",
  components: {
  },
  data() {
    return {

    }
  },
  methods: {
    convertToPdf() {
      const content = this.$refs.contentToConvert;

      // Configuration options for PDF generation
      const options = {
        filename: 'converted.pdf', // PDF 文件名
        image: { type: 'jpeg', quality: 0.98 }, // 图片质量
        html2canvas: {}, // html2canvas 选项
        jsPDF: { unit: 'px', format: 'a4', orientation: 'portrait' } // jsPDF 选项
      };

      // Convert HTML content to PDF
      // html2pdf().from(content).set(options).save();

    },

    save() {
      const content = this.$refs.contentToConvert;

      // Configuration options for PDF generation
      const options = {
        filename: 'converted.pdf', // PDF 文件名
        image: { type: 'jpeg', quality: 0.98 }, // 图片质量
        html2canvas: {}, // html2canvas 选项
        jsPDF: { unit: 'px', format: 'a4', orientation: 'portrait' } // jsPDF 选项
      };
      html2pdf().from(content).set(options).save();
    },
    doPDF() {
      const content = this.$refs.contentToConvert;

      // Configuration options for PDF generation
      const options = {
        filename: 'converted.pdf', // PDF 文件名
        image: { type: 'jpeg', quality: 0.98 }, // 图片质量
        html2canvas: {}, // html2canvas 选项
        jsPDF: { unit: 'px', format: 'a4', orientation: 'portrait' } // jsPDF 选项
      };
      html2pdf().from(content).set(options).outputPdf().then(pdf => {

        const pdfData = pdf.output('datauristring');
        const newTab = window.open();
        newTab.document.write('<iframe src="' + pdfData + '" width="100%" height="100%"></iframe>');

        // Add download button
        newTab.document.write('<a href="' + pdfData + '" download="' + options.filename + '">Download PDF</a>');

        // Add print button
        newTab.document.write('<button onclick="printPdf()">Print PDF</button>');

        // Print PDF function
        newTab.printPdf = function () {
          this.focus(); // Focus on the new window
          this.print(); // Print the PDF
        };

      });
    }
  }

};
</script>


<style lang="scss">
.page {
  border: none;
}

.content-div {
  width: 100%;
  height: 100vh;
}
</style>